module.exports = "pegasus/assets/pexels-logo.png";